import { getFetchWrapper } from '@syf-api-library/core';
import { utilityJWEUrl } from '../endpoints';
export const queryFnFactoryToken = (config, keyProps, headers = {}) => {
    const fetchWrapper = getFetchWrapper(config);
    return () => {
        const params = new URLSearchParams({
            'cipher.accountId': keyProps.accountId
        });
        if (keyProps.accountIdType) {
            params.set('accountIdType', keyProps.accountIdType);
        }
        return fetchWrapper(`${utilityJWEUrl}?${params}`, {
            method: 'GET',
            headers
        });
    };
};
